import React, { useState, useEffect } from 'react';
import { api_url } from "./globalFunction/global_string";
import DataTable from 'react-data-table-component';
import { SiteTitle } from "./SiteTitle";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './FetchTrackingDetail.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';

const MySwal = withReactContent(Swal);


function FetchWAFDetail() {
    const [trackingData, setTrackingData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modal, setModal] = useState(false); // 定義模態對話框狀態
    const [editData, setEditData] = useState({});  // 編輯按鈕使用
    const [selectedId, setSelectedId] = useState(null);  //保存的時候帶ID
    const [selectedFiles, setSelectedFiles] = useState([]); //選擇檔案放置位置
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [reportCollapseStatus, setReportCollapseStatus] = useState({}); //追蹤報告標題收合使用
    const location = useLocation();
    const { build_date, projectName } = location.state || {};




    //利用scan_id來做分組函數       
    const groupByproblemID = (data) => {
        return data.reduce((groups, item) => {
            const key = `${item.id}`;
            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(item);
            return groups;
        }, {});
    };
    const loadData = async () => {
        setIsLoading(true);
        let apiUrl = `${api_url}/api/TrackBackground/GetUNitOneTrackWAFDetail`;
        const formData = new FormData();
        formData.append("build_date", build_date);
        formData.append("projectName", projectName);
        formData.append("projectnet", localStorage.getItem('login_user_net_id'));
        formData.append("projectunit", localStorage.getItem('login_user_unit_id'));

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (response.ok && data.statusCode === 200) {
                const groupedData = groupByproblemID(data.row);
                console.log(groupedData)
                setTrackingData(groupedData);
            } else {
                throw new Error('無效的回應格式');
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };


    useEffect(() => {
        if (build_date, projectName) {
            loadData();
        }
    }, [build_date, projectName]);



    if (isLoading) {
        return <div>正在加載...</div>;
    }

    if (error) {
        return <div>發生錯誤: {error}</div>;
    }
    function combinePdfData(trackingData) {
        const groupedData = {};

        trackingData.forEach(item => {
            const key = `${item.projectId}`;

            if (!groupedData[key]) {
                groupedData[key] = { ...item, problemSupportingInformation: [], noteFiles: [] };
            }

            if (item.problemSupportingInformation && item.problemSupportingInformation.trim() !== '') {
                groupedData[key].problemSupportingInformation.push({
                    fileName: item.problemSupportingInformation.split('\\').pop(),
                    filepath: item.problemSupportingInformation,
                    fileId: item.problemFileId
                });
            }
            if (item.noteFile && item.noteFile.trim() !== '') {
                groupedData[key].noteFiles.push({
                    fileName: item.noteFile.split('\\').pop(),
                    filepath: item.noteFile,
                    fileId: item.problemFileId
                });
            }
        });

        return Object.values(groupedData).map(item => {
            return {
                ...item,
                problemSupportingInformation: item.problemSupportingInformation.map(file => file.fileName).join(', '),
                problemSupportingInformations: item.problemSupportingInformation,
                noteFile: item.noteFiles.map(file => file.fileName).join(', '),
                noteFiles: item.noteFiles
            };
        });
    }



    // function combinePdfData(trackingData) {
    //     const combinedData = [];
    //     Object.entries(trackingData).forEach(([id, groupData]) => {
    //         // 將所有同一 id 的 PDF 資料和 noteFile 資料結合，同時保留對應的 problemFileId
    //         const combinedPdf = groupData.map(data => {
    //             return {
    //                 problemSupportingInformation: data.problemSupportingInformation,
    //                 problemFileId: data.problemFileId
    //             };
    //         }).filter(info => info.problemSupportingInformation);

    //         const combinedNoteFile = groupData.map(data => data.noteFile).filter(note => note).join(', ');

    //         // 假設 groupData[0] 包含了除 PDF 和 noteFile 資料外的其他共享信息
    //         combinedData.push({
    //             ...groupData[0],
    //             problemSupportingInformation: combinedPdf,
    //             noteFile: combinedNoteFile
    //         });
    //     });

    //     return combinedData;
    // }


    //佐證資料傳檔案使用
    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        const maxFileSize = 10 * 1024 * 1024; // 10MB
        const maxFiles = 10;

        const validFiles = files.filter(file => file.size <= maxFileSize);
        if (validFiles.length > maxFiles) {
            MySwal.fire({
                title: '錯誤',
                text: `最多只能上傳 ${maxFiles} 個文件`,
                icon: 'error',
                confirmButtonText: '確定',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
            return;
        }
        if (validFiles.length !== files.length) {
            MySwal.fire({
                title: '警告',
                text: '某些文件超過了大小限制（10MB）',
                icon: 'warning',
                confirmButtonText: '確定',
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            });
        }


        // 更新狀態以保存選定的文件
        setSelectedFiles(validFiles);

        setEditData({
            ...editData,
            ProblemSupportingInformation: validFiles,
        });
    };
    //刪除檔案
    const handleRemoveFile = async (fileId, index) => {
        // 移除本地狀態中的檔案
        setUploadedFiles(currentFiles => {
            const updatedFiles = [...currentFiles];
            updatedFiles.splice(index, 1);
            const updatedNoteFile = updatedFiles.map(file => file.path).join(', ');
            setEditData(currentEditData => ({ ...currentEditData, noteFile: updatedNoteFile }));
            return updatedFiles;
        });

        // 準備發送到後端的請求
        let formData = new FormData();
        formData.append('id', fileId);
        const apiUrl = `${api_url}/api/TrackBackground/DelProblemFile`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            if (!response.ok) {
                throw new Error('刪除文件時發生錯誤');
            }

            // 處理成功的響應
            const data = await response.json();
            if (data.statusCode === 200) {
                Swal.fire({
                    title: '成功!',
                    text: '此檔案已刪除成功',
                    icon: 'success',
                    confirmButtonText: '好的'
                })
            }
        } catch (error) {
            console.error('刪除文件時發生錯誤', error);
        }
    };


    // 修改按鈕事件處理
    const handleEdit = (data) => {
        console.log(data);
        const updatedData = {
            ...data,
            problemProcessingMethod: data.problemProcessingMethod ?? '5'
        };

        setEditData(updatedData);
        setSelectedId(data.id);
        setSelectedFiles([]);

        if (data.problemSupportingInformations && Array.isArray(data.problemSupportingInformations)) {
            // 直接處理物件陣列
            const pdfFiles = data.problemSupportingInformations.map((fileInfo) => {
                console.log(fileInfo)
                return {
                    id: fileInfo.fileId, // 從物件中直接取得 fileId
                    name: fileInfo.fileName, // 直接使用處理過的 fileName
                    path: fileInfo.filepath
                };
            });
            setUploadedFiles(pdfFiles);
        } else {
            setUploadedFiles([]);
        }

        toggleModal();
    };


    // 更新數據的函數
    const handleUpdate = async () => {

        let formData = new FormData();
        Object.keys(editData).forEach(key => {
            formData.append(key, editData[key]);
        });
        if (selectedFiles) {
            selectedFiles.forEach(file => {
                formData.append("Files", file);
            });
        }
        let apiUrl = `${api_url}/api/TrackBackground/PutUNitOneReportDetail`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            const data = await response.json();
            if (data.statusCode === 200) {
                loadData();
                toggleModal();
            } else {
                Swal.fire({
                    title: '錯誤',
                    text: data.detail,
                    icon: 'error',
                    confirmButtonText: '好的'
                });
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    // 切換模態對話框的顯示狀態
    const toggleModal = () => {
        setModal(!modal);
    };




    const handleDownload = async (filePath) => {
        const segments = filePath.split('\\');
        const fileNameWithExtension = segments.pop();
        const encodedFileName = encodeURIComponent(fileNameWithExtension);
        const encodedPath = segments.join('/');
        const fileUrl = `${api_url}/${encodedPath}/${encodedFileName}`;
        console.log(fileUrl);

        try {
            const response = await fetch(fileUrl);
            if (!response.ok) {
                throw new Error(`Server responded with ${response.status}: ${response.statusText}`);
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', decodeURIComponent(encodedFileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error('Failed to fetch file:', error);
        }
    };



    // 追蹤報告標題切換收合/展開狀態的函數
    const toggleReportCollapse = scanId => {
        setReportCollapseStatus(prevStatus => ({
            ...prevStatus,
            [scanId]: !prevStatus[scanId]
        }));
    };

    const userType = localStorage.getItem('login_user_type');
    const username = localStorage.getItem('login_user_name');


    let columns = [
        {
            name: '問題類型',
            selector: row => row.problemType,
            sortable: true,
            cell: row => <div className="wrap-text">{row.problemType}</div>
        },
        {
            name: '處理方式',
            selector: row => row.problemProcessingMethod,
            sortable: false,
            cell: row => {
                const ProcessingMethodMapping = {
                    '5': '無',
                    '6': '建置於校內平台',
                    '7': '建置於合規公有雲'
                };
                return <div className="wrap-text">{ProcessingMethodMapping[row.problemProcessingMethod]}</div>;
            }
        },
        {
            name: '改善回應',
            selector: row => row.problemimProvementResponse,
            sortable: false,
            cell: row => <div className="wrap-text">{row.problemimProvementResponse}</div>
        },
        {
            name: '佐證資料',
            selector: row => row.problemSupportingInformation,
            sortable: false,
            cell: row => {
                if (row.problemSupportingInformations && Array.isArray(row.problemSupportingInformations)) {
                    return (
                        <div className="wrap-text">
                            {row.problemSupportingInformations.map((fileInfo, index) => {
                                const { fileName, filepath } = fileInfo;
                                const fileExtension = fileName.toLowerCase().match(/\.(pdf|html?)$/i);
                                let iconSrc = "/PDF.png";
                                if (fileExtension) {

                                    switch (fileExtension[1]) {
                                        case "pdf":
                                            iconSrc = "/PDF.png";
                                            break;
                                        case "html":
                                            iconSrc = "/html.png";
                                        default:
                                            break;
                                    }
                                }
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={iconSrc} alt={fileExtension ? fileExtension[1].toUpperCase() : "File"} style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '5px' }} />
                                        <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(filepath)}>{fileName}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    return <div></div>; // 如果沒有資料，顯示空白
                }
            }
        },
        {
            name: '備註',
            selector: row => row.note,
            sortable: false,
            cell: row => <div className="wrap-text">{row.note}</div>
        },
        {
            name: '備註檔案',
            selector: row => row.noteFile,
            sortable: false,
            cell: row => {
                if (row.noteFiles && Array.isArray(row.noteFiles)) {
                    return (
                        <div className="wrap-text">
                            {row.noteFiles.map((fileInfo, index) => {
                                const { fileName, filepath } = fileInfo;
                                const fileExtension = fileName.toLowerCase().match(/\.(pdf|html?)$/i);
                                let iconSrc = "/PDF.png";
                                if (fileExtension) {

                                    switch (fileExtension[1]) {
                                        case "pdf":
                                            iconSrc = "/PDF.png";
                                            break;
                                        case "html":
                                            iconSrc = "/html.png";
                                        default:
                                            break;
                                    }
                                }
                                return (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
                                        <img src={iconSrc} alt={fileExtension ? fileExtension[1].toUpperCase() : "File"} style={{ width: '20px', height: '20px', cursor: 'pointer', marginRight: '5px' }} />
                                        <span style={{ cursor: 'pointer' }} onClick={() => handleDownload(filepath)}>{fileName}</span>
                                    </div>
                                );
                            })}
                        </div>
                    );
                } else {
                    return <div></div>;
                }

            }
        },
        {
            name: '操作',
            cell: row => {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const projectEndTime = new Date(row.projectEndTime);
                projectEndTime.setHours(0, 0, 0, 0);

                if (row.isWAFreport === 2 || projectEndTime < today) {
                    return null;
                }
                return (
                    <div>
                        {/* 當row.isadminbuildWAF為true且row.isadminWAF為false時檢查userType */}
                        {row.isadminbuildWAF && (
                            <>
                                {userType === 'M' && row.isUnitTrack && (
                                    <Button color="primary" onClick={() => handleEdit(row)}>區網修改</Button>
                                )}
                                {/* 這個按鈕在任何條件下都會顯示 */}
                                <Button color="primary" onClick={() => handleEdit(row)}>單位修改</Button>

                            </>
                        )}

                        {row.isNetbuildWAF && (
                            <>
                                {userType === 'M' && row.isNetAndWAF === false && (
                                    <Button color="primary" onClick={() => handleEdit(row)}>區網修改</Button>
                                )}
                                {userType === 'N' && row.isUnitWAF === false && (
                                    <Button color="primary" onClick={() => handleEdit(row)}>單位修改</Button>
                                )}
                            </>
                        )}

                        {/* 當row.isUnitbuildWAF為true且row.isUnitWAF為true時顯示單位修改按鈕 */}
                        {userType === 'N' && row.isUnitbuildWAF && row.isUnitWAF && (
                            <Button color="primary" onClick={() => handleEdit(row)}>單位修改</Button>
                        )}
                    </div>
                );

            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        }
    ];

    let netbuildWAFProcessed = false;
    if (trackingData) {
        Object.entries(trackingData).forEach(([id, groupData]) => {
            groupData.forEach(data => {
                if (data.isNetbuildWAF === true && !netbuildWAFProcessed) {
                    if (data.problemPreliminaryResults !== undefined || data.problemPreliminaryOpinion !== undefined) {
                        netbuildWAFProcessed = true;
                        const indexAfterSupportingInformation = columns.findIndex(column => column.name === '佐證資料') + 1;
                        const newColumns = [
                            {
                                name: '審核結果',
                                selector: row => row.problemPreliminaryResults,
                                sortable: false,
                                cell: row => {
                                    const ResultsLevelMapping = {
                                        '5': '無',
                                        '6': '通過',
                                        '7': '未通過',
                                    };
                                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                                }
                            },
                            {
                                name: '審核意見',
                                selector: row => row.problemPreliminaryOpinion,
                                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
                            },

                        ];
                        columns = [
                            ...columns.slice(0, indexAfterSupportingInformation),
                            ...newColumns,
                            ...columns.slice(indexAfterSupportingInformation)
                        ];
                    }
                } else if (data.isUnitbuildWAF === true && !netbuildWAFProcessed) {
                    if (data.problemPreliminaryResults !== undefined || data.problemPreliminaryOpinion !== undefined) {
                        netbuildWAFProcessed = true;
                        const indexAfterSupportingInformation = columns.findIndex(column => column.name === '佐證資料') + 1;
                        const newColumns = [
                            {
                                name: '審核結果',
                                selector: row => row.problemPreliminaryResults,
                                sortable: false,
                                cell: row => {
                                    const ResultsLevelMapping = {
                                        '5': '無',
                                        '6': '通過',
                                        '7': '未通過',
                                    };
                                    return <div className="wrap-text">{ResultsLevelMapping[row.problemPreliminaryResults]}</div>;
                                }
                            },
                            {
                                name: '審核意見',
                                selector: row => row.problemPreliminaryOpinion,
                                cell: row => <div className="wrap-text">{row.problemPreliminaryOpinion}</div>
                            },

                        ];
                        columns = [
                            ...columns.slice(0, indexAfterSupportingInformation),
                            ...newColumns,
                            ...columns.slice(indexAfterSupportingInformation)
                        ];
                    }
                }
            });
        });
    }



    const shouldShowSubmitButton = (groupData) => {
        return groupData.some(data => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const projectEndTime = new Date(data.projectEndTime);
            projectEndTime.setHours(0, 0, 0, 0);

            if (data.isWAFreport === 2 || projectEndTime < today) {
                return false;
            }

            if (data.isadminbuildWAF) {
                if (userType === 'M' && data.isUnitWAF === true) {
                    return true;
                }
                if (userType === 'N' && data.isUnitWAF === false) {
                    return true;
                }
            }
            if (data.isNetbuildWAF) {

                if (userType === 'M' && data.isNetAndWAF === false) {
                    return true;
                }
                if (userType === 'N' && data.isUnitWAF === false) {
                    return true;
                }
            }
            if (data.isUnitbuildWAF && data.isUnitWAF) {
                return true;
            }
            return false;
        });
    };


    //單筆提交功能
    const handleSubmit = async (groupData, scanId) => {
        console.log(groupData)
        console.log(scanId)
        const t1Id = groupData.map(item => item.trbg0101Id);

        let confirmSubmit = false;

        confirmSubmit = await Swal.fire({
            title: '確定提交報告?',
            text: '提交後內容將無法更改',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then(result => {
            return result.isConfirmed
        });

        if (!confirmSubmit) {
            return;
        }
        const formData = new FormData();
        formData.append('ids', scanId)
        t1Id.forEach(id => formData.append('t1Id', id));
        formData.append('local_unit_id', localStorage.getItem('login_user_unit_id'));
        formData.append('local_net_id', localStorage.getItem('login_user_net_id'));
        formData.append('user_type', userType);
        formData.append('username', localStorage.getItem('login_user_name'));
        let apiUrl = `${api_url}/api/TrackBackground/UNitWAFFunticon`;

        try {
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: { "Authorization": localStorage.getItem('accessToken') },
                body: formData
            });
            if (response.ok) {
                await loadData();
                Swal.fire({
                    icon: 'success',
                    title: '【提交成功】',
                    text: '恭喜'
                });
            } else {
                console.error("提交失败", response);
            }
        } catch (error) {
            console.error("提交时出现错误", error);
        }
    }
    return (
        <div >
            <SiteTitle />
            {Object.entries(trackingData).map(([scanId, groupData], index) => {
                return (
                    <div key={index} className="dataTable-wrapper">
                        <div className="dataTable-header">
                            <div className="header-item">
                                網站名稱: <a href={groupData[0].url_addr} target="_blank" rel="noopener noreferrer">{groupData[0].url_name}</a>
                                <Button onClick={() => toggleReportCollapse(scanId)} style={{ marginLeft: '10px' }}>
                                    {reportCollapseStatus[scanId] ? '展開' : '收起來'}
                                </Button>
                                {shouldShowSubmitButton(groupData) && (
                                    <Button onClick={() => handleSubmit(groupData, scanId)} style={{ marginLeft: '10px' }}>
                                        單筆提交
                                    </Button>
                                )}
                            </div>
                        </div>
                        {!reportCollapseStatus[scanId] && (
                            <DataTable
                                noHeader
                                columns={columns}
                                // className="dataTable-container"
                                data={combinePdfData(groupData)}
                            />
                        )}
                    </div>
                );
            })}



            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>修改數據</ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label for="problemType">問題類型</Label>
                            <Input
                                type="text"
                                name="problemType"
                                id="problemType"
                                value={editData.problemType}
                                onChange={e => setEditData({ ...editData, problemType: e.target.value })}
                                readOnly
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="problemProcessingMethod">處理方式</Label>
                            <Input
                                type="select"
                                name="problemProcessingMethod"
                                id="problemProcessingMethod"
                                value={editData.problemProcessingMethod}
                                onChange={e => setEditData({ ...editData, problemProcessingMethod: e.target.value })}
                            >
                                <option value="5">無</option>
                                <option value="6">建置於校內平台</option>
                                <option value="7">建置於合規公有雲</option>
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label for="problemimProvementResponse">改善回應</Label>
                            <Input
                                type="textarea"
                                name="problemimProvementResponse"
                                id="problemimProvementResponse"
                                value={editData.problemimProvementResponse}
                                onChange={e => setEditData({ ...editData, problemimProvementResponse: e.target.value })}
                                rows="10"
                                style={{ resize: 'none', overflow: 'auto' }}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="problemSupportingInformation">佐證資料</Label>
                            <Input
                                type="file"
                                name="problemSupportingInformation"
                                id="problemSupportingInformation"
                                multiple
                                onChange={handleFileChange}
                                accept=".pdf"
                            />
                            <div className="uploaded-files">
                                {uploadedFiles.map((file, index) => (
                                    <div key={index}>
                                        <span>{index + 1}. {file.name}</span>
                                        <Button onClick={() => handleRemoveFile(file.id, index)}>
                                            <FontAwesomeIcon icon={faTimes} />
                                        </Button>
                                    </div>
                                ))}
                            </div>
                        </FormGroup>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => handleUpdate(selectedId)}>保存</Button>{' '}
                    <Button color="secondary" onClick={toggleModal}>取消</Button>
                </ModalFooter>
            </Modal>
        </div>
    );

}

export default FetchWAFDetail;